<div class="card">
  <div>
    <h3 class="card-title">
      {{ 'bill.vat.label' | translate }}
      {{
        order.currency && order.currency.id
          ? (order.currency.id | translate)
          : (core.services.user?.user?.company?.currency?.id | translate)
      }}
    </h3>
  </div>
  <div class="table-responsive">
    <!--    todo show later, TN-->
    <!--    <table class="table m-0">-->
    <!--      <tbody *ngIf="order && order.rounding && order.rounding !== 0">-->
    <!--      <tr *ngIf="order && order.rounding && order.rounding !== 0">-->
    <!--        <th class="no-hover" colspan="4">-->
    <!--          {{ 'order.rounding' | translate }}-->
    <!--        </th>-->
    <!--      </tr>-->
    <!--      <tr *ngIf="(order && order.rounding && order.rounding !== 0) && order.items && order.items.length > 0">-->
    <!--        <td class="text-end no-hover">{{ order.items[0].vat.percent || 0 }}%</td>-->
    <!--        <td class="text-end no-hover">-->
    <!--          {{ (order.rounding * order.items[0].vat.coefficient).toFixed(2) }}-->
    <!--          {{-->
    <!--          order.currency?.id-->
    <!--            ? (order.currency.id | translate)-->
    <!--            : (core.services.user?.user?.company?.currency?.id | translate)-->
    <!--          }}-->
    <!--        </td>-->
    <!--        <td class="text-end no-hover">-->
    <!--          {{ order.rounding.toFixed(2) }}-->
    <!--          {{-->
    <!--          order.currency.id-->
    <!--            ? (order.currency.id | translate)-->
    <!--            : (core.services.user?.user?.company?.currency?.id | translate)-->
    <!--          }}-->
    <!--        </td>-->
    <!--      </tr>-->
    <!--      </tbody>-->
    <!--    </table>-->
    <table class="table m-0">
      @if (!order.vatAllocations || order.vatAllocations?.length < 1) {
        <div class="text-center">
          {{ 'no.items' | translate }}
        </div>
      }
      @if (order.vatAllocations && order.vatAllocations.length > 0) {
        <thead>
          <tr>
            <th class="text-end">{{ 'bill.vat.rate' | translate }}</th>
            <th class="text-end">{{ 'bill.vat.base' | translate }}</th>
            <th class="text-end">{{ 'bill.vat.vat' | translate }}</th>
            <th class="text-end">{{ 'bill.vat.total' | translate }}</th>
          </tr>
        </thead>
      }
      @if (order.vatAllocations && order.vatAllocations.length > 0) {
        <tbody>
          @for (row of order.vatAllocations; track row) {
            <tr>
              @if (row.vat) {
                <td class="text-end no-hover">{{ row.vat.percent }}%</td>
              }
              @if (!row.vat) {
                <td class="text-end no-hover">Celkem</td>
              }
              <td class="text-end no-hover text-nowrap">
                {{
                  row.priceWithoutVat
                    ? (row.priceWithoutVat | formatPrice: order?.currency)
                    : ('0.00' | formatPrice: order?.currency)
                }}
              </td>
              <td class="text-end no-hover text-nowrap">
                {{
                  row.vatPrice ? (row.vatPrice | formatPrice: order?.currency) : ('0.00' | formatPrice: order?.currency)
                }}
              </td>
              <td class="text-end no-hover text-nowrap">
                {{ row.price ? (row.price | formatPrice: order?.currency) : ('0.00' | formatPrice: order?.currency) }}
              </td>
            </tr>
          }
        </tbody>
      }
    </table>
  </div>
</div>
